import ArrowLink from "@/components/base/ArrowLink";
import SectionLabel from "@/components/base/SectionLabel";
import { company } from "@/mocks/site";

const facts = [
  { label: "Gegründet", value: "1963 in Geschwand" },
  { label: "Generation", value: "Dritte Generation" },
  { label: "Standort", value: `Geschwand, ${company.city}` },
  { label: "Geschäftsführung", value: company.manager },
];

export default function HomeIntro() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-9 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-7">
            <SectionLabel className="mb-5">Willkommen</SectionLabel>
            <h2 className="max-w-xl font-heading text-[26px] font-extrabold leading-[1.1] tracking-tightest text-foreground-950 sm:text-[32px] md:text-[38px]">
              Ein Familienbetrieb aus der
              <br className="hidden sm:block" /> Fränkischen Schweiz.
            </h2>

            <div className="mt-6 max-w-xl space-y-4 text-[14px] leading-[1.75] text-foreground-700 md:text-[15px]">
              <p>
                Seit 1963 entwickeln und fertigen wir in Geschwand technische Lösungen, die es
                nicht von der Stange gibt — vom Einzelteil über Vorrichtungen bis zur kompletten
                Anlage. In dritter Generation, mit eigener Halle und kurzen Wegen.
              </p>
              <p>
                Wer bei uns anfragt, spricht mit Menschen, die die Werkstatt kennen. Über 60 Jahre
                Erfahrung aus verschiedensten Branchen fließen in jede Anforderung ein — nach der
                Devise: Qualität und Individualität, made in Germany.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-3">
              <ArrowLink to="/unternehmen">Unternehmen</ArrowLink>
              <ArrowLink to="/produkte">Produkte</ArrowLink>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative h-full overflow-hidden border border-foreground-800 bg-foreground-950 p-6 text-background-50 md:p-7">
              <div className="blueprint absolute inset-0 opacity-30" />
              <div className="relative flex h-full flex-col">
                <p className="font-label text-[10px] uppercase tracking-[0.22em] text-primary-400">
                  Auf einen Blick
                </p>
                <dl className="mt-5 flex flex-col divide-y divide-foreground-800">
                  {facts.map((fact) => (
                    <div
                      key={fact.label}
                      className="flex flex-col gap-1 py-3 sm:flex-row sm:items-baseline sm:justify-between sm:gap-4"
                    >
                      <dt className="font-label text-[10px] uppercase tracking-[0.16em] text-background-500">
                        {fact.label}
                      </dt>
                      <dd className="text-left text-[13px] font-medium text-background-200 sm:text-right">
                        {fact.value}
                      </dd>
                    </div>
                  ))}
                </dl>
                <div className="mt-auto pt-5">
                  <a
                    href={`tel:${company.phoneHref}`}
                    className="flex items-center gap-2 font-label text-[13px] text-background-100 transition-colors hover:text-primary-300"
                  >
                    <i className="ri-phone-line text-[14px] text-primary-400" />
                    {company.phone}
                  </a>
                  <a
                    href={`mailto:${company.email}`}
                    className="mt-2 flex items-center gap-2 font-label text-[13px] text-background-100 transition-colors hover:text-primary-300"
                  >
                    <i className="ri-mail-line text-[14px] text-primary-400" />
                    {company.email}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}